module.exports = __webpack_public_path__ + "img/enerfuture-scenario-2023-edition.aa3b1b0.png";